import { z } from 'zod';

export const paginationSchema = z.object({
  totalItems: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  limit: z.number().int().positive(),
  totalPages: z.number().int().nonnegative(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
});

export const withPaginationSchema = <T>(schema: z.ZodType<T>) => {
  return z.object({
    items: z.array(schema),
    pagination: paginationSchema,
  });
};

export type PaginatedResponse<T> = z.infer<ReturnType<typeof withPaginationSchema>> & {
  items: T[];
};

export const parseSearchParams = (
  params: Record<string, string | number | boolean | null | undefined>,
): URLSearchParams => {
  const searchParams = new URLSearchParams();

  for (const [ key, value ] of Object.entries(params)) {
    if (value !== null && value !== undefined) {
      searchParams.append(key, String(value));
    }
  }
  return searchParams;
};

const getCognitoTokenExp = (token: string) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1])) as { exp: number | undefined };
    return payload.exp ? payload.exp * 1000 : null;
  }
  catch {
    return null;
  }
};

export const isCognitoTokenExpired = (token: string | null) => {
  if (!token) return true;
  const expirationTime = getCognitoTokenExp(token);
  if (!expirationTime) return true;

  // return true if it expires in the next 30 seconds
  const buffer = 30000;
  return Date.now() > (expirationTime - buffer);
};
